module.exports = __webpack_public_path__ + "static/media/Mazatlan.77c0c918.jpg";